const translations = {
  en: {
    // Header & Nav
    home: "Home",
    reviewLinkGenerator: "Review Link Generator",
    results: "Results",
    howItWorks: "How it Works",
    pricing: "Pricing",
    tools: "Tools",
    dashboard: "Dashboard",
    login: "Login",
    signUp: "Sign up",
    getStartedFree: "Get Started Free",
    logout: "Logout",
    freeAudit: "Free Audit",
    account: "Account",
    backToHome: "Back to home",
    backToSite: "Back to site",

    // Language Toggle
    english: "English",
    arabic: "العربية",

    // Hero Section
    heroBannerTag: "AI-drafted replies for every Google review — approved by you before they post",
    heroTitleLine1: "Automate your Google Business reviews",
    heroTitleAccent: "now",
    heroSub: "ReplyShoot uses AI to draft a personalized reply to every review your business receives, usually within 24 hours. You preview each one and approve it by email before it's posted — nothing goes out without your sign-off.",
    heroSubBold: " You run your business, we handle the replies.",
    heroCta: "See Your Unanswered Reviews",
    heroNote: "Free to check your reviews. No credit card required.",
    statLocalBrands: "local brands analyzed",
    statReviewsProcessed: "customer reviews processed",
    statHipaaCompliant: "100% HIPAA-compliant",
    statWorkflowsClinics: "workflows for clinics",
    statZeroLockIn: "Zero lock-in contracts",
    statCancelAnytime: "cancel at any time",

    // Stats Bar
    statsBar1: "of local companies ignore critical online complaints",
    statsBar2: "average increase in sales with proactive reputation tracking",
    statsBar3: "of shoppers favor local brands that actively reply to reviewers",
    statsBar4: "of buyers search for local ratings before visiting a business",

    // Problem Section
    problemTitle: "The True Expense of",
    problemTitleAccent: "Unresolved Customer Feedback",
    problemSub: "Proven search data highlights the impact of leaving buyers in silence.",
    buyersLost: "prospective buyers lost",
    buyersLostSub: "for each unanswered critical comment",
    hoursSaved: "productive hours saved monthly",
    hoursSavedSub: "by outsourcing individual response drafting",
    authorsUnanswered: "of review authors",
    authorsUnansweredSub: "report never receiving any reply from local businesses",
    mathTitle: "Let's look at the numbers:",
    mathText1: "For example, if a customer is worth ",
    mathText2: " to your business, losing ",
    mathText3: " to unanswered reviews adds up to ",
    mathText4: "in missed opportunity. ReplyShoot starts at just ",

    // Compare Section
    managingSolo: "Managing Solo",
    withReplyShoot: "With ReplyShoot",
    solo1: "Unsatisfied reviews sit unresolved for weeks",
    solo2: "Shoppers assume customer support is non-existent",
    solo3: "Competitors who reply consistently make a stronger impression on new customers",
    solo4: "You waste valuable hours drafting individual replies by hand",
    solo5: "Uncontested 1-star ratings permanently damage your overall score",
    rs1: "Every review receives a tailored, polite reply within 24 hours",
    rs2: "Prospective clients see an active, responsive local brand",
    rs3: "An active, responsive profile makes a stronger impression on potential customers",
    rs4: "You spend zero hours drafting — just approve via inbox",
    rs5: "Unhappy reviews are transformed into loyalty-building moments",

    // Reviews Section
    reviewsTitle: "Real Examples of",
    reviewsTitleAccent: "Brand Replies We Craft",
    reviewsSub: "Personalized, context-aware replies drafted by AI and matched to your brand voice.",
    ownerResponse: "Owner Response — by ReplyShoot",
    respondedIn: "Responded in",
    getResponsesLikeThese: "Get Responses Like These for Your Business",

    // How It Works Section
    howTitle: "You build your business.",
    howTitleAccent: "We curate your feedback.",
    howSub: "Quick 15-minute onboarding. Moving forward, you will spend less than 5 minutes a week verifying drafts.",
    step1Title: "Brand Voice Integration",
    step1Text: "We conduct a quick 15-minute setup call to align on your unique brand voice, guidelines, and core offerings. We write just like you.",
    step2Title: "Tailored Draft Generation",
    step2Text: "The moment a new review appears, our AI creates a personalized, context-aware reply within 24 hours, matched to your brand voice.",
    step3Title: "One-Click Inbox Approval",
    step3Text: "You receive a clean email notification: review the drafted response and click 'Approve' to post. Nothing goes public without your explicit consent.",

    // VS Section
    vsTitle: "Software Doesn't Do the Work.",
    vsTitleAccent: "We Do.",
    vsSoftwareLabel: "Subscription Software",
    vsSoftware1: "You must log in and write all replies yourself",
    vsSoftware2: "Yet another complex dashboard to master",
    vsSoftware3: "Stiff, generic template replies that don't sound like you",
    vsSoftware4: "$200 to $400 monthly for unused software",
    vsRsLabel: "ReplyShoot",
    vsRs1: "AI drafts every reply for you, matched to your brand voice",
    vsRs2: "Zero dashboards — one-click approval via email",
    vsRs3: "Highly personalized to fit your exact brand tone",
    vsRs4: "Starts at $15/mo for complete management",
    vsDiyLabel: "In-House DIY",
    vsDiy1: "Wastes 6 to 8 hours of premium owner time monthly",
    vsDiy2: "Highly inconsistent response times",
    vsDiy3: "Risk of writing emotional replies to bad reviews",
    vsDiy4: "Constantly pushed down your daily to-do list",

    // Proof Section
    proofTitle: "Active Engagement",
    proofTitleAccent: "Drives Growth",
    proof1Label: "average sales growth for local brands responding to 25%+ of feedback",
    proof2Label: "increase in overall business revenue per 0.5 star rating improvement",
    proof3Label: "of local searchers choose brands that reply to every review",
    proof4Label: "of new buyers read rating profiles prior to making a purchase decision",

    // Pricing Section
    pricingTitle: "Clear, Straightforward",
    pricingTitleAccent: "Plans",
    pricingSub: "No hidden fees. No long-term commitments. Scale or cancel instantly.",
    monthly: "Monthly",
    annually: "Annually",
    mostPopular: "Most Popular",
    getStarted: "Get Started",
    perMonth: "/month",
    perYear: "/year",
    pkgStarterDesc: "Excellent for new local businesses establishing their brand.",
    pkgStarterF1: "Up to 10 crafted responses monthly",
    pkgStarterF2: "Email-based approval system",
    pkgStarterF3: "24-hour delivery target",
    pkgStarterF4: "Aligned brand voice profile",
    pkgProDesc: "Perfect for growing brands aiming to scale their reputation.",
    pkgProF1: "Up to 40 crafted responses monthly",
    pkgProF2: "Email-based approval system",
    pkgProF3: "24-hour delivery target",
    pkgProF4: "Aligned brand voice profile",
    pkgProF5: "Priority response for critical feedback",
    pkgProF6: "Comprehensive monthly analytics report",
    pkgUltraDesc: "Tailored for busy locations and multi-unit brands.",
    pkgUltraF1: "Unlimited crafted responses monthly",
    pkgUltraF2: "Email-based approval system",
    pkgUltraF3: "Express 12-hour response window",
    pkgUltraF4: "Aligned brand voice profile",
    pkgUltraF5: "Priority response for critical feedback",
    pkgUltraF6: "Weekly analytics & insight reports",
    pkgUltraF7: "Dedicated personal reputation specialist",

    // FAQ Section
    faqTitle: "Frequently Asked",
    faqTitleAccent: "Questions",
    faq1Q: "Why shouldn't I just write replies myself?",
    faq1A: "While you certainly can, most local business owners simply don't have the time to keep up consistently. Unresolved reviews build up quickly, and prospective buyers often go with whichever business responds first. We remove the operational headache entirely.",
    faq2Q: "How do you capture my specific brand voice?",
    faq2A: "During onboarding, we align on your unique business values, vocabulary preferences, and tone guidelines. Since nothing is published without your direct one-click email approval, you retain complete control over every single word.",
    faq3Q: "Is this service worth the monthly cost?",
    faq3A: "Consider the value of a single customer. If keeping just one buyer from choosing a competitor covers your subscription, it's already paid for itself. Most owners find it one of the most time-effective ways to stay on top of their reviews.",
    faq4Q: "What if I want to edit a drafted reply?",
    faq4A: "You have absolute authority. Each draft is delivered to your inbox, allowing you to easily request modifications or customize the text before it is published on your profile.",
    faq5Q: "My business doesn't receive reviews very often.",
    faq5A: "If you have a low volume of reviews, each rating carries significantly more weight. A single unaddressed low rating can heavily impact your average star score. Promptly responding to each review protects your rating from fluctuations.",
    faq6Q: "Why not just copy-paste from AI generators?",
    faq6A: "Generic AI tools don't know your business, your brand voice, or the specific review they're replying to, so replies often come out sounding robotic and generic. ReplyShoot's AI is built specifically for review replies — it drafts something tailored to your brand and to each review, and you still approve every single one before it's posted.",

    // CTA Section
    ctaTitle: "Keep Your Review Profile Active.",
    ctaSub: "Get a free, personalized review report for your business.",
    scanReviewsNow: "Scan My Business Reviews Now",
    ctaNote: "Free analysis. No payment details required.",

    // Footer
    privacyPolicy: "Privacy Policy",
    refundPolicy: "Refund Policy",
    termsAndPolicies: "Terms & Policies",
    allRightsReserved: "© 2026 ReplyShoot – All Rights Reserved",

    // Auth & Modals
    welcomeBack: "Welcome Back",
    signInToAccount: "Sign in to your ReplyShoot account",
    emailLabel: "Email",
    passwordLabel: "Password",
    enterEmail: "Enter your email",
    enterPassword: "Enter your password",
    signingIn: "Signing in...",
    signIn: "Sign In",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    createAccount: "Create Account",
    joinReplyShoot: "Join ReplyShoot to reply to every review",
    businessNameLabel: "Business Name",
    fullNameLabel: "Full name",
    enterBusinessName: "Enter your business name",
    confirmPasswordLabel: "Confirm Password",
    creatingAccount: "Creating Account...",
    showText: "Show",
    hideText: "Hide",
    forgotPasswordLink: "Forgot password?",
    noPlanSelected: "No plan selected",

    // Audit Page
    freeReviewAudit: "Free Review Audit",
    auditHeroSub: "See how many of your Google reviews are unanswered, and preview AI-drafted replies for each one.",
    cityLabel: "City",
    stateLabel: "State",
    selectState: "Select...",
    findMyBusiness: "Find My Business",
    searching: "Searching...",
    noSignupRequired: "No sign-up required. We'll find your business on Google Maps.",
    selectYourBusiness: "Select your business",
    searchAgain: "Search again",
    analyzingReviews: "Analyzing Your Reviews",
    analyzingSub: "We're scanning your Google reviews and generating AI-powered insights. This typically takes 1–3 minutes.",
    cancel: "Cancel",
    analysisComplete: "Analysis Complete!",
    analysisCompleteSub: "Your reputation audit is ready. Click below to view your detailed report with AI-suggested responses.",
    viewReport: "View Report",
    trustedBy: "Built for local businesses, big and small",
    persuasionTitle: "Your reviews are your reputation.",
    persuasionTitleAccent: "Don't let them go unanswered.",
    persuasionDesc: "88% of local customers choose businesses that reply to their reviews (BrightLocal, 2024). Staying on top of yours helps keep that edge.",
    avgSalesLift: "average sales lift (Womply)",
    guaranteedResponse: "typical response time",
    perMonthToStart: "per month to start",
    writtenByExperts: "Personalized to every review — never a generic template",
    youApproveEveryReply: "You approve every reply before it's posted",
    zeroContracts: "Zero contracts · Cancel anytime",
    first7DaysFree: "Instant setup in under 15 minutes. Cancel anytime.",

    // Audit Result Page
    reputationAuditReport: "Reputation Audit Report",
    generatedOn: "Generated",
    totalReviewsOnGoogle: "total reviews on Google",
    reputationScore: "Reputation Score",
    responseRateLabel: "Response rate",
    unansweredReviewsLabel: "Unanswered reviews",
    negativeHighestPriority: "Negative — highest priority",
    estRevenueAtRiskLabel: "Est. revenue at risk",
    subscriptionDetails: "Subscription details",
    revenueRiskCalc: "Revenue Risk Calculator",
    setAvgTxVal: "Set your average transaction value to see the real dollar cost of ignored reviews.",
    estRevenueAtRisk: "Est. Revenue at Risk",
    responseHealthOverview: "Response Health Overview",
    reviewResponseRate: "Review Response Rate",
    respondedTo: "You responded to",
    recentReviewsText: "recent reviews",
    respondingBenchmark: "Businesses responding to 25%+ of reviews earn 35% more revenue on average (Womply, 200K+ SMBs)",
    unansweredNegative: "Unanswered negative reviews",
    negUrgency: "1–2 stars · Highest urgency",
    unansweredNeutral: "Unanswered neutral reviews",
    neuUrgency: "3 stars · Recoverable with a reply",
    unansweredPositive: "Unanswered positive reviews",
    posUrgency: "4–5 stars · Missed loyalty opportunity",
    reputationScoreBreakdown: "Reputation Score Breakdown",
    reputationGrade: "Reputation Grade",
    revenueImpactAnalysis: "Revenue Impact Analysis",
    stopLosingCustomers: "Reply to every review, and keep more customers.",
    letUsReplyForYou: " Let us reply for you — starting at $15/mo.",
    teaserCtaSubText: "Our AI drafts a personalized, brand-aligned reply to every review, usually within 24 hours. You review and approve — we do the rest. Zero contracts, cancel any time.",
    humanWrittenFeature: "Personalized to each review, never a generic template",
    youApproveFeature: "You approve every reply before it posts",
    first7DaysFreeFeature: "Cancel anytime, no long-term contract",
    startNow: "Start Now!",
    setupTimeNote: "Setup takes under 15 minutes · Instant access",
    aiSuggestedResponses: "AI-Suggested Responses",
    heresWhatWeWouldSay: "Here's what we'd say for you",
    professionalBrandAligned: "Professional, brand-aligned responses crafted for your unanswered reviews — ready in seconds.",
    sampleResponses: "sample responses",
    replyShootSuggestedResponse: "ReplyShoot Suggested Response",
    aiDrafted: "AI-Drafted",
    nextSteps: "Next Steps",
    emailThisReport: "Email this report",
    receivePdfCopy: "Receive a PDF copy of this audit plus a free monthly check-in on how your reputation is trending.",
    sendReportBtn: "Send Report",
    sendingBtn: "Sending...",
    letUsHandleThisTitle: "Let us handle this for you",
    letUsHandleThisDesc: "We respond to every review — positive and negative — in your brand voice, within 24 hours. You simply approve via email.",
    startingAt15Mo: "Starting at $15/month · Cancel anytime · No contracts",
    runAnotherAudit: "Run another audit",

    // Tools Page
    toolsTitle: "Local Brand Reputation Toolset",
    toolsSub: "Professional tools designed to help you analyze, optimize, and scale your local ratings without subscription costs.",
    toolsTag: "Complimentary reputation toolset for local businesses",
    useTool: "Use tool →",
    tool1Title: "Brand Feedback Audit",
    tool1Desc: "Quickly see how many of your online reviews have gone unanswered, and what a reply could be worth.",
    tool2Title: "Smart Reply Generator",
    tool2Desc: "Enter any customer comment to immediately draft a polite, brand-aligned response tailored to your tone.",
    tool3Title: "Star Rating Goal Estimator",
    tool3Desc: "Calculate precisely how many consecutive 5-star ratings are needed to raise your business profile to your target score.",
    tool4Title: "Response Impact Estimator",
    tool4Desc: "Provide your typical transaction size to estimate the potential impact of unanswered reviews.",
    tool5Title: "HIPAA Safety Validator",
    tool5Desc: "Paste your review reply to instantly scan for potential medical confidentiality or HIPAA exposure hazards.",
    tool6Title: "Review Request Copy Blueprints",
    tool6Desc: "Copy-paste proven SMS and email templates to ask your customers for honest Google reviews.",

    // Onboarding Page
    howShouldWeSound: "How should we sound?",
    matchBrandVoice: "We'll match your brand voice in every response.",
    toneProfessional: "Professional",
    toneProfessionalDesc: "Polished and business-like. Great for medical, legal, and financial services.",
    toneFriendly: "Friendly & Warm",
    toneFriendlyDesc: "Approachable and conversational. Great for restaurants, salons, and retail.",
    toneCasual: "Casual",
    toneCasualDesc: "Relaxed and laid-back. Great for cafes, fitness studios, and creative businesses.",
    toneEmpathetic: "Empathetic & Caring",
    toneEmpatheticDesc: "Sensitive and understanding. Great for healthcare, wellness, and childcare.",
    uniqueQuestion: "What makes your business unique?",
    avoidQuestion: "Anything we should avoid saying?",
    continueToPlan: "Continue to Plan Selection",
    chooseYourPlan: "Choose your plan",
    noContractsNoFees: "Cancel anytime. No contracts. No setup fees.",
    planStarterDetails: "1 location, Google reviews, 48hr response",
    planProDetails: "1 location, Google + Yelp + Facebook, 24hr response",
    planMultiDetails: "Up to 3 locations, all platforms, 24hr response",
    continueToPayment: "Continue to Payment",
    savingText: "Saving...",

    // Payment Page
    completeSubscription: "Complete your subscription",
    trustPanelSub: "Join hundreds of local businesses that trust ReplyShoot to keep their reviews active and build customer trust.",
    guaranteeTitle: "Cancel Anytime, No Contracts",
    guaranteeText: "You're never locked in - cancel your subscription at any time directly from your dashboard.",
    copywritersTitle: "Personalized, Not Generic",
    copywritersText: "Every reply is AI-drafted and matched to your brand's unique voice — never a generic template.",
    controlTitle: "You Keep Full Control",
    controlText: "No reply is ever published without your approval. Verify every draft with one click via email.",
    secureCheckoutPaddle: "Secure checkout powered by Paddle. Your payment details are fully encrypted and PCI-DSS compliant.",
    orderSummary: "Order Summary",
    monthlyLabel: "Monthly",
    billedAnnually: "Billed Annually",
    save20: "Save 20%",
    receiptEmail: "Receipt Email Address",
    receiptEmailPlaceholder: "you@yourbusiness.com",
    continueToCheckout: "Continue to Secure Checkout",
    goBack: "Go Back",

    // Connect Google & OAuth
    connectGoogleAccount: "Connect Your Google Account",
    googleConnectSub: "Authorise ReplyShoot to securely fetch your reviews and post AI-generated replies — all on your behalf, 24/7.",
    googleConnectTag: "Google Business Profile",
    step1Title: "Click \"Connect Google\"",
    step1Desc: "You'll be securely redirected to Google's authorization page.",
    step2Title: "Grant Permissions",
    step2Desc: "Google will ask you to allow access to view and reply to your Business Profile reviews.",
    step3Title: "Google Sends a Code",
    step3Desc: "After you approve, Google redirects back to our app with a secure authorization code.",
    step4Title: "Tokens Saved Securely",
    step4Desc: "We exchange the code for access tokens and store them encrypted — ready to fetch and reply to reviews.",
    perm1: "View your Google Business Profile locations",
    perm2: "Read all customer reviews on your profile",
    perm3: "Post replies to reviews on your behalf",
    perm4: "View basic account information (name, email)",
    checkingConnectionStatus: "Checking connection status…",
    googleAccountConnected: "Google Account Connected",
    noGoogleAccountConnected: "No Google Account Connected",
    followStepsBelow: "Follow the steps below to get started.",
    reconnectBtn: "Reconnect",
    connectingGoogle: "Connecting to Google...",
    authorizingGoogle: "Authorizing with Google...",
    exchangingCode: "Exchanging authorization code securely...",
    connectionSuccessful: "Google Account Successfully Connected!",
    autoRedirecting: "Redirecting to your dashboard in a few seconds...",
    connectionFailed: "Google Connection Failed",
    connectionDenied: "Access Consent Denied",
    connectionDeniedSub: "You cancelled the Google permission request. We need your permission to fetch and manage reviews.",
    tryConnectingAgain: "Try Connecting Again",
    goToDashboard: "Go to Dashboard",

    // Dashboard (Customer & Admin)
    menu: "Menu",
    overview: "Overview",
    reviews: "Reviews",
    brandVoice: "Brand Voice Settings",
    connectedLocations: "Connected Locations",
    analytics: "Analytics",
    billing: "Account / Billing",
    allCustomers: "All Customers",
    auditRequests: "Audit Requests",
    packageManager: "Package Manager",
    systemSettings: "System Settings",
    approve: "Approve",
    edit: "Edit",
    reject: "Reject",
    saveChanges: "Save Changes",
    savedSuccessfully: "Saved successfully!",
    locationsConnectedLabel: "Locations Connected",
    activePlanLabel: "Active Plan",
    // Policy Pages (Terms, Privacy, Refund)
    termsSub: "The terms of service and conditions for utilizing our review management platform.",
    termsP1: "These Terms and Policies describe the conditions under which you may use ReplyShoot’s services, including review auditing, AI-generated response recommendations, and subscription management.",
    acceptanceTitle: "Acceptance",
    acceptanceDesc: "By accessing or using ReplyShoot, you agree to these Terms, our Privacy Policy, and any additional policies published on our website.",
    eligibilityTitle: "Eligibility",
    eligibilityDesc: "Use of our services is limited to individuals and businesses capable of entering into binding agreements. You represent that you are at least 18 years old and authorized to accept these Terms on behalf of the entity you represent.",
    serviceDescTitle: "Service Description",
    serviceDescContent: "ReplyShoot provides tools to audit online reviews, suggest customer response messaging, and help local businesses improve their online reputation. Our platform offers guidance and automation, but cannot guarantee specific review outcomes or ranking improvements.",
    userRespTitle: "User Responsibilities",
    userResp1: "Provide accurate business information during registration and audit requests.",
    userResp2: "Use the service lawfully and respect intellectual property rights.",
    userResp3: "Review and approve any AI-generated content before publishing or posting.",
    userResp4: "Protect your account credentials and report unauthorized access immediately.",
    billingFeesTitle: "Billing and Fees",
    billingFeesDesc: "Subscription pricing, billing terms, and payment terms are defined at purchase. You agree to pay all applicable fees and follow posted billing policies.",
    ipTitle: "Intellectual Property",
    ipDesc: "All ReplyShoot content, software, designs, and trademarks are owned by ReplyShoot or our licensors. You may not reproduce, distribute, or create derivative works without express permission.",
    thirdPartyTitle: "Third-Party Services",
    thirdPartyDesc: "ReplyShoot may integrate with third-party platforms, including review sites, analytics providers, and payment gateways. Use of those services is subject to their own terms and privacy policies.",
    disclaimerTitle: "Disclaimer and Liability",
    disclaimerDesc: "ReplyShoot provides services \"as is\" without warranties of merchantability or fitness for a particular purpose. We are not liable for indirect, incidental, or consequential damages arising from your use of our platform.",
    terminationTitle: "Termination",
    terminationDesc: "We may suspend or terminate your access for violations of these Terms, nonpayment, or misuse of the platform. You may cancel your subscription at any time in accordance with our cancellation and refund policies.",
    termsChangesTitle: "Changes",
    termsChangesDesc: "We may modify these Terms and Policies at any time. Material changes will be posted on our site and may be communicated by email. Continued use of ReplyShoot after updates constitutes acceptance.",

    privacySub: "How ReplyShoot collects, uses, discloses, and safeguards your information.",
    privacyP1: "This Privacy Policy explains how ReplyShoot collects, uses, discloses, and safeguards information when you use our review management and AI response services. It applies to users of our website, audit tools, onboarding flows, and related support services.",
    infoWeCollectTitle: "Information We Collect",
    infoWeCollectSub: "We collect information needed to provide our services effectively and securely.",
    contactDetailsTitle: "Contact and account details:",
    contactDetailsDesc: "name, email address, business name, phone number, and other information you submit during signup or onboarding.",
    reviewDataTitle: "Review and reputation data:",
    reviewDataDesc: "review text, ratings, timestamps, platform identifiers, and any business details needed to generate accurate audit and response recommendations.",
    usageInfoTitle: "Usage information:",
    usageInfoDesc: "browser and device data, page views, session activity, and analytics information collected through cookies and server logs.",
    howWeUseTitle: "How We Use Your Information",
    howWeUseSub: "We use your data to deliver products and improve overall experience.",
    howWeUse1: "Provide review auditing, AI response drafting, onboarding, and subscription management.",
    howWeUse2: "Personalize our recommendations and tailor responses to your brand voice.",
    howWeUse3: "Send service notifications, billing information, and support communications.",
    howWeUse4: "Analyze product usage, improve performance, and develop new features.",
    infoSharingTitle: "Information Sharing",
    infoSharingSub: "We share information only as required to operate the service and when legally necessary.",
    serviceProvidersTitle: "Service providers:",
    serviceProvidersDesc: "trusted partners that support hosting, analytics, payment processing, and email delivery.",
    legalRequestsTitle: "Legal requests:",
    legalRequestsDesc: "when required by law or to protect ReplyShoot, our customers, or others.",
    businessTransfersTitle: "Business transfers:",
    businessTransfersDesc: "in connection with mergers, acquisitions, or asset sales.",
    securityRetentionTitle: "Security and Retention",
    securityRetentionDesc: "We maintain reasonable safeguards designed to protect your data. We retain information only as long as necessary to provide services, comply with legal obligations, and resolve disputes.",
    yourRightsTitle: "Your Rights",
    yourRightsDesc: "You may have rights to access, correct, delete, or object to certain uses of your personal information under applicable law. Contact us if you wish to exercise these rights.",
    cookiesTrackingTitle: "Cookies and Tracking",
    cookiesTrackingDesc: "Cookies and similar technologies help us operate the website, remember preferences, and collect analytics data for continuous improvement.",
    policyUpdatesTitle: "Updates",
    policyUpdatesDesc: "We may update this policy periodically. Any material changes will be posted on our website, and continued use of the service constitutes acceptance of the updated policy.",

    refundSub: "Clear guidelines on refund conditions, rules, and calculation methods.",
    refundP1: "This Refund Policy explains how refunds are handled for monthly and annual subscriptions to ReplyShoot. It is intended to provide clear expectations and examples for eligible refund requests.",
    monthlySubsTitle: "Monthly Subscriptions",
    monthlySubsSub: "Monthly subscriptions are evaluated based on the billing cycle and the date the refund request is submitted.",
    firstHalfTitle: "First half of the month:",
    firstHalfDesc: "Refund requests submitted during the first half of the billing month are eligible for a refund equal to 50% of the current month’s fee.",
    secondHalfTitle: "Second half of the month:",
    secondHalfDesc: "Requests submitted during the second half of the billing month are not eligible for a refund of the current month’s fee.",
    exampleLabel: "Example:",
    monthlyExample: "If your billing period begins on the 1st and you request a refund on the 10th, you may receive a 50% refund for that month. If the request is made on the 20th, the current month is considered fully earned.",
    annualSubsTitle: "Annual Subscriptions",
    annualSubsSub: "Annual subscriptions use the same monthly half-cycle rule for the current month, plus a refund for any remaining unused full months.",
    annualRule1: "If the refund request is submitted in the first half of the current month, 50% of the current month’s charge is refundable.",
    annualRule2: "If the request is submitted in the second half, the current month is non-refundable.",
    annualRule3: "The remaining unused full months of the annual term are refunded at the equivalent monthly rate.",
    annualExample: "If your annual billing date is January 5 and you request a refund on March 8, you may receive 50% of March plus refunds for the unused months of April through December. If you request a refund on March 20, you would be eligible only for remaining full months.",
    processingTitle: "Processing",
    processingDesc: "Refunds are issued to the payment method used for purchase. Processing times vary by payment provider and may take several business days.",
    cancellationAccessTitle: "Cancellation and Access",
    cancellationAccessDesc: "When a refund is approved, your subscription may remain active through the end of the paid period unless stated otherwise in your account notification.",
    refundUpdatesTitle: "Policy Updates",
    refundUpdatesDesc: "ReplyShoot may change this Refund Policy at any time. Updated policies will be posted on our website and apply to future purchases and refund requests.",
  },
  ar: {
    // Header & Nav
    home: "الرئيسية",
    reviewLinkGenerator: "مولد رابط المراجعات",
    results: "النتائج",
    howItWorks: "كيف يعمل",
    pricing: "الأسعار",
    tools: "الأدوات",
    dashboard: "لوحة التحكم",
    login: "تسجيل الدخول",
    signUp: "إنشاء حساب",
    getStartedFree: "ابدأ مجاناً",
    logout: "تسجيل الخروج",
    freeAudit: "تدقيق مجاني",
    account: "الحساب",
    backToHome: "العودة للرئيسية",
    backToSite: "العودة للموقع",

    // Language Toggle
    english: "English",
    arabic: "العربية",

    // Hero Section
    heroBannerTag: "ردود مصاغة بالذكاء الاصطناعي لكل مراجعة على Google — تتم الموافقة عليها من قبلك قبل النشر",
    heroTitleLine1: "أتمتة مراجعات Google Business الخاصة بك",
    heroTitleAccent: "الآن",
    heroSub: "يستخدم ReplyShoot الذكاء الاصطناعي لصياغة رد مخصص لكل مراجعة يحصل عليها نشاطك التجاري، عادةً خلال 24 ساعة. تقوم بمعاينة كل رد والموافقة عليه عبر البريد الإلكتروني قبل نشره — لا يُنشر شيء دون موافقتك.",
    heroSubBold: " أنت تدير عملك، ونحن نتولى الردود.",
    heroCta: "اطّلع على مراجعاتك بدون رد",
    heroNote: "فحص مراجعاتك مجاني. لا حاجة لبطاقة ائتمان.",
    statLocalBrands: "علامة تجارية محلية تم تحليلها",
    statReviewsProcessed: "مراجعة عميل تم معالجتها",
    statHipaaCompliant: "100٪ متوافق مع HIPAA",
    statWorkflowsClinics: "مسارات عمل خاصة بالعيادات",
    statZeroLockIn: "عقود بدون التزام طويل الأجل",
    statCancelAnytime: "إلغاء في أي وقت",

    // Stats Bar
    statsBar1: "من الشركات المحلية تكتفي بتجاهل الشكاوى الحرجة عبر الإنترنت",
    statsBar2: "متوسط زيادة المبيعات مع تتبع السمعة الاستباقي",
    statsBar3: "من المتسوقين يفضلون العلامات التجارية التي تجيب بنشاط على المراجعين",
    statsBar4: "من المشترين يبحثون عن التقييمات المحلية قبل زيارة النشاط التجاري",

    // Problem Section
    problemTitle: "التكلفة الحقيقية لـ",
    problemTitleAccent: "ملاحظات العملاء غير المحلولة",
    problemSub: "توضح بيانات البحث الموثوقة تأثير ترك المشترين في صمت.",
    buyersLost: "مشترون محتملون مفقودون",
    buyersLostSub: "لكل تعليق حرج لم يتم الرد عليه",
    hoursSaved: "ساعات إنتاجية موفرة شهرياً",
    hoursSavedSub: "من خلال الاستعانة بمصادر خارجية لصياغة الردود",
    authorsUnanswered: "من كتاب المراجعات",
    authorsUnansweredSub: "يفيدون بعدم تلقي أي رد من الشركات المحلية",
    mathTitle: "دعنا ننظر إلى الأرقام:",
    mathText1: "على سبيل المثال، إذا كانت قيمة العميل ",
    mathText2: " لنشاطك التجاري، فإن خسارة ",
    mathText3: " بسبب مراجعات غير معالجة يعني خسارة ",
    mathText4: " من الفرص الضائعة. يبدأ ReplyShoot من ",

    // Compare Section
    managingSolo: "الإدارة بمفردك",
    withReplyShoot: "مع ReplyShoot",
    solo1: "تبقى المراجعات غير الراضية بدون حل لأسابيع",
    solo2: "يفترض المتسوقون عدم وجود دعم للعملاء",
    solo3: "المنافسون الذين يردون باستمرار يتركون انطباعاً أقوى لدى العملاء الجدد",
    solo4: "تضيع ساعات قيمة في صياغة الردود الفردية يدوياً",
    solo5: "التقييمات ذات النجمة الواحدة تلحق ضرراً دائماً بنتيجتك الإجمالية",
    rs1: "تتلقى كل مراجعة رداً مخصصاً ومهذباً خلال 24 ساعة",
    rs2: "يرى العملاء المحتملون علامة تجارية محلية نشطة وتستجيب",
    rs3: "الملف النشط والمتجاوب يترك انطباعاً أقوى لدى العملاء المحتملين",
    rs4: "لا تقضي أي ساعات في الصياغة — فقط وافق عبر البريد",
    rs5: "تتحول المراجعات غير السعيدة إلى لحظات تبني الولاء",

    // Reviews Section
    reviewsTitle: "أمثلة حقيقية لـ",
    reviewsTitleAccent: "ردود العلامة التجارية التي نصيغها",
    reviewsSub: "ردود مخصصة ومدركة للسياق تتم صياغتها بالذكاء الاصطناعي وتتناسب مع صوت علامتك التجارية.",
    ownerResponse: "رد المالك — بواسطة ReplyShoot",
    respondedIn: "تم الرد خلال",
    getResponsesLikeThese: "احصل على ردود مثل هذه لنشاطك التجاري",

    // How It Works Section
    howTitle: "أنت تبني عملك.",
    howTitleAccent: "نحن ندير ردودك وملاحظاتك.",
    howSub: "إعداد سريع خلال 15 دقيقة. عند الانطلاق، ستقضي أقل من 5 دقائق أسبوعياً للتحقق من المسودات.",
    step1Title: "دمج صوت العلامة التجارية",
    step1Text: "نجري مكالمة إعداد سريعة لمدة 15 دقيقة للتوافق مع صوت علامتك التجارية الفريد وإرشاداتك وخدماتك الأساسية.",
    step2Title: "إنشاء مسودة مخصصة",
    step2Text: "في اللحظة التي تظهر فيها مراجعة جديدة، ينشئ الذكاء الاصطناعي لدينا رداً مخصصاً ومدركاً للسياق خلال 24 ساعة، بما يتناسب مع صوت علامتك التجارية.",
    step3Title: "موافقة بنقرة واحدة عبر البريد",
    step3Text: "تتلقى إشعاراً نظيفاً عبر البريد الإلكتروني: راجع الرد المصاغ وانقر على 'موافقة' للنشر.",

    // VS Section
    vsTitle: "البرامج لا تقوم بالعمل.",
    vsTitleAccent: "نحن نقوم به.",
    vsSoftwareLabel: "برامج الاشتراكات",
    vsSoftware1: "يجب عليك تسجيل الدخول وكتابة جميع الردود بنفسك",
    vsSoftware2: "لوحة تحكم معقدة أخرى يتعين عليك إتقانها",
    vsSoftware3: "ردود عامة وجامدة من قوالب جاهزة لا تعكس صوتك",
    vsSoftware4: "من 200 إلى 400 دولار شهرياً لبرامج غير مستخدمة",
    vsRsLabel: "ReplyShoot",
    vsRs1: "الذكاء الاصطناعي يصيغ كل رد نيابة عنك، بما يتناسب مع صوت علامتك التجارية",
    vsRs2: "بدون لوحات تحكم — موافقة بنقرة واحدة عبر البريد",
    vsRs3: "مخصصة للغاية لتناسب نبرة علامتك التجارية تماماً",
    vsRs4: "تبدأ من 15 دولاراً/شهر للإدارة الكاملة",
    vsDiyLabel: "القيام بذلك بنفسك في الشركة",
    vsDiy1: "تضيع من 6 إلى 8 ساعات من وقت صاحب العمل الثمين شهرياً",
    vsDiy2: "أوقات استجابة غير متناسقة للغاية",
    vsDiy3: "خطر كتابة ردود عاطفية على المراجعات السيئة",
    vsDiy4: "تتأجل باستمرار في قائمة مهامك اليومية",

    // Proof Section
    proofTitle: "التفاعل النشط",
    proofTitleAccent: "يدفع النمو",
    proof1Label: "متوسط نمو المبيعات للعلامات التجارية المحلية التي تستجيب لـ 25%+ من الملاحظات",
    proof2Label: "زيادة في إيرادات الأعمال الإجمالية لكل تحسن 0.5 في تقييم النجوم",
    proof3Label: "من الباحثين المحليين يختارون العلامات التجارية التي تجيب على كل مراجعة",
    proof4Label: "من المشترين الجدد يقرأون ملفات التقييم قبل اتخاذ قرار الشراء",

    // Pricing Section
    pricingTitle: "خطة واضحة و",
    pricingTitleAccent: "مباشرة",
    pricingSub: "لا رسوم خفية. لا التزامات طويلة الأجل. توسع أو ألغ فوراً.",
    monthly: "شهري",
    annually: "سنوي",
    mostPopular: "الأكثر شعبية",
    getStarted: "ابدأ الآن",
    perMonth: "/شهر",
    perYear: "/سنة",
    pkgStarterDesc: "ممتاز للشركات المحلية الجديدة التي تؤسس علامتها التجارية.",
    pkgStarterF1: "حتى 10 ردود مصاغة شهرياً",
    pkgStarterF2: "نظام موافقة مستند إلى البريد الإلكتروني",
    pkgStarterF3: "هدف التسليم خلال 24 ساعة",
    pkgStarterF4: "ملف صوت علامة تجارية متوافق",
    pkgProDesc: "مثالي للعلامات التجارية المتنامية التي تهدف لتعزيز سمعتها.",
    pkgProF1: "حتى 40 رداً مصاغاً شهرياً",
    pkgProF2: "نظام موافقة مستند إلى البريد الإلكتروني",
    pkgProF3: "هدف التسليم خلال 24 ساعة",
    pkgProF4: "ملف صوت علامة تجارية متوافق",
    pkgProF5: "استجابة أولوية للملاحظات الحرجة",
    pkgProF6: "تقرير تحليلي شهري شامل",
    pkgUltraDesc: "مصمم خصيصاً للمواقع المزدحمة والعلامات التجارية متعددة الفروع.",
    pkgUltraF1: "ردود مصاغة غير محدودة شهرياً",
    pkgUltraF2: "نظام موافقة مستند إلى البريد الإلكتروني",
    pkgUltraF3: "نافذة استجابة سريعة خلال 12 ساعة",
    pkgUltraF4: "ملف صوت علامة تجارية متوافق",
    pkgUltraF5: "استجابة أولوية للملاحظات الحرجة",
    pkgUltraF6: "تقارير تحليلات ورؤى أسبوعية",
    pkgUltraF7: "مختص سمعة شخصي مخصص",

    // FAQ Section
    faqTitle: "الأسئلة",
    faqTitleAccent: "الشائعة",
    faq1Q: "لماذا لا أكتب الردود بنفسي فقط؟",
    faq1A: "بينما يمكنك ذلك بالتأكيد، فإن معظم أصحاب الأعمال المحلية ليس لديهم الوقت الكافي للمتابعة باستمرار. تتراكم المراجعات المعلقة بسرعة، وغالباً ما يفضل المشترون المحتملون النشاط التجاري الذي يرد أولاً. نحن نزيل هذا العبء التشغيلي تماماً.",
    faq2Q: "كيف تلتقطون صوت علامتي التجارية المحدد؟",
    faq2A: "أثناء الإعداد، نتوافق مع قيم عملك الفريدة وتفضيلات المفردات وإرشادات النبرة. وبما أنه لا يتم نشر أي شيء بدون موافقتك الصريحة عبر البريد الإلكتروني، فأنت تحتفظ بالسيطرة الكاملة على كل كلمة.",
    faq3Q: "هل هذه الخدمة تستحق التكلفة الشهرية؟",
    faq3A: "فكر في قيمة عميل واحد. إذا كان الاحتفاظ بعميل واحد فقط من الذهاب إلى منافس يغطي تكلفة اشتراكك، فقد حقق ذلك عائده بالفعل. يجد معظم أصحاب الأعمال أنها من أكثر الطرق فعالية من حيث الوقت لمتابعة مراجعاتهم.",
    faq4Q: "ماذا لو أردت تعديل رد مصاغ؟",
    faq4A: "لديك السلطة المطلقة. يتم تسليم كل مسودة إلى صندوق الوارد الخاص بك، مما يسمح لك بطلب التعديلات أو تخصيص النص قبل نشره.",
    faq5Q: "عملي لا يتلقى مراجعات بشكل متكرر.",
    faq5A: "إذا كان لديك حجم مراجعات منخفض، فإن كل تقييم يحمل وزناً أكبر بكثير. يمكن لتقييم منخفض واحد أن يؤثر بشكل كبير على متوسط نتيجتك. الاستجابة الفورية تحمي تقييمك.",
    faq6Q: "لماذا لا أنسخ وألصق من مولدات الذكاء الاصطناعي؟",
    faq6A: "أدوات الذكاء الاصطناعي العامة لا تعرف نشاطك التجاري ولا صوت علامتك التجارية ولا تفاصيل المراجعة التي ترد عليها، لذا غالباً ما تبدو ردودها عامة وآلية. الذكاء الاصطناعي في ReplyShoot مصمم خصيصاً للرد على المراجعات — يصوغ رداً مخصصاً لعلامتك التجارية ولكل مراجعة، وأنت من يوافق على كل رد قبل نشره.",

    // CTA Section
    ctaTitle: "حافظ على نشاط ملف تقييماتك.",
    ctaSub: "احصل على تقرير مجاني ومخصص لمراجعات نشاطك التجاري.",
    scanReviewsNow: "افحص مراجعات عملي الآن",
    ctaNote: "تحليل مجاني. لا حاجة لبيانات الدفع.",

    // Footer
    privacyPolicy: "سياسة الخصوصية",
    refundPolicy: "سياسة الاسترداد",
    termsAndPolicies: "الشروط وسياسات الخدمة",
    allRightsReserved: "© 2026 ReplyShoot – جميع الحقوق محفوظة",

    // Auth & Modals
    welcomeBack: "مرحباً بعودتك",
    signInToAccount: "تسجيل الدخول إلى حسابك في ReplyShoot",
    emailLabel: "البريد الإلكتروني",
    passwordLabel: "كلمة المرور",
    enterEmail: "أدخل بريدك الإلكتروني",
    enterPassword: "أدخل كلمة المرور",
    signingIn: "جاري تسجيل الدخول...",
    signIn: "تسجيل الدخول",
    dontHaveAccount: "ليس لديك حساب؟",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    createAccount: "إنشاء حساب",
    joinReplyShoot: "انضم إلى ReplyShoot للرد على كل مراجعة",
    businessNameLabel: "اسم النشاط التجاري",
    fullNameLabel: "الاسم الكامل",
    enterBusinessName: "أدخل اسم نشاطك التجاري",
    confirmPasswordLabel: "تأكيد كلمة المرور",
    creatingAccount: "جاري إنشاء الحساب...",
    showText: "إظهار",
    hideText: "إخفاء",
    forgotPasswordLink: "نسيت كلمة المرور؟",
    noPlanSelected: "لم يتم تحديد خطة",

    // Audit Page
    freeReviewAudit: "تدقيق المراجعات المجاني",
    auditHeroSub: "اكتشف عدد مراجعاتك على Google التي لا تزال بدون رد، واطّلع على ردود مقترحة بالذكاء الاصطناعي لكل منها.",
    cityLabel: "المدينة",
    stateLabel: "الولاية / المنطقة",
    selectState: "اختر...",
    findMyBusiness: "ابحث عن نشاطي التجاري",
    searching: "جاري البحث...",
    noSignupRequired: "لا يتطلب التسجيل. سنجد نشاطك التجاري على خرائط Google.",
    selectYourBusiness: "حدد نشاطك التجاري",
    searchAgain: "البحث مرة أخرى",
    analyzingReviews: "جاري تحليل مراجعاتك",
    analyzingSub: "نحن نفحص مراجعات Google الخاصة بك وننشيء رؤى مدعومة بالذكاء الاصطناعي. يستغرق هذا من 1 إلى 3 دقائق.",
    cancel: "إلغاء",
    analysisComplete: "اكتمل التحليل!",
    analysisCompleteSub: "تدقيق سمعتك جاهز. انقر أدناه لعرض تقريرك المفصل مع الردود المقترحة.",
    viewReport: "عرض التقرير",
    trustedBy: "مصمم للشركات المحلية بمختلف أحجامها",
    persuasionTitle: "مراجعاتك هي سمعتك.",
    persuasionTitleAccent: "لا تدعها تبق بدون إجابة.",
    persuasionDesc: "88% من العملاء المحليين يختارون الشركات التي ترد على مراجعاتها (BrightLocal، 2024). متابعة مراجعاتك تساعدك على الحفاظ على هذه الميزة.",
    avgSalesLift: "متوسط زيادة المبيعات (Womply)",
    guaranteedResponse: "وقت استجابة معتاد",
    perMonthToStart: "لكل شهر للبدء",
    writtenByExperts: "مخصصة لكل مراجعة — ليست قالباً عاماً أبداً",
    youApproveEveryReply: "أنت توافق على كل رد قبل نشره",
    zeroContracts: "بدون عقود · إلغاء في أي وقت",
    first7DaysFree: "إعداد فوري في أقل من 15 دقيقة. يمكنك الإلغاء في أي وقت.",

    // Audit Result Page
    reputationAuditReport: "تقرير تدقيق السمعة",
    generatedOn: "تم إنشاؤه في",
    totalReviewsOnGoogle: "إجمالي المراجعات على Google",
    reputationScore: "درجة السمعة",
    responseRateLabel: "معدل الاستجابة",
    unansweredReviewsLabel: "المراجعات غير المعالجة",
    negativeHighestPriority: "سلبية — أعلى أولوية",
    estRevenueAtRiskLabel: "الإيرادات المقدرة المعرضة للخطر",
    subscriptionDetails: "تفاصيل الاشتراك",
    revenueRiskCalc: "حاسبة مخاطر الإيرادات",
    setAvgTxVal: "حدد متوسط قيمة معاملتك لرؤية التكلفة الحقيقية بالدولار للمراجعات المتجاهلة.",
    estRevenueAtRisk: "الإيرادات المقدرة المعرضة للخطر",
    responseHealthOverview: "نظرة عامة على صحة الاستجابة",
    reviewResponseRate: "معدل الاستجابة للمراجعات",
    respondedTo: "لقد أجبت على",
    recentReviewsText: "مراجعات حديثة",
    respondingBenchmark: "الشركات التي تستجيب لـ 25%+ من المراجعات تحقق إيرادات أكثر بنسبة 35% في المتوسط",
    unansweredNegative: "مراجعات سلبية غير معالجة",
    negUrgency: "1–2 نجوم · أعلى درجة إلحاح",
    unansweredNeutral: "مراجعات محايدة غير معالجة",
    neuUrgency: "3 نجوم · قابلة للاسترداد برد",
    unansweredPositive: "مراجعات إيجابية غير معالجة",
    posUrgency: "4–5 نجوم · فرصة ولاء مفقودة",
    reputationScoreBreakdown: "تفاصيل درجة السمعة",
    reputationGrade: "درجة السمعة",
    revenueImpactAnalysis: "تحليل تأثير الإيرادات",
    stopLosingCustomers: "رد على كل مراجعة، واحتفظ بمزيد من العملاء.",
    letUsReplyForYou: " دعنا نجيب نيابة عنك — تبدأ من 15 دولاراً/شهر.",
    teaserCtaSubText: "يصيغ الذكاء الاصطناعي لدينا رداً مخصصاً ومتوافقاً مع علامتك التجارية لكل مراجعة، عادةً خلال 24 ساعة. أنت تراجع وتوافق — ونحن نفعل الباقي. بدون عقود، إلغاء في أي وقت.",
    humanWrittenFeature: "مخصصة لكل مراجعة، وليست قالباً عاماً أبداً",
    youApproveFeature: "تتوافق وتوافق على كل رد قبل نشره",
    first7DaysFreeFeature: "يمكنك الإلغاء في أي وقت، بدون عقود طويلة الأجل",
    startNow: "ابدأ الآن!",
    setupTimeNote: "الإعداد يستغرق أقل من 15 دقيقة · وصول فوري",
    aiSuggestedResponses: "الردود المقترحة بالذكاء الاصطناعي",
    heresWhatWeWouldSay: "إليك ما سنقوله نيابة عنك",
    professionalBrandAligned: "ردود احترافية ومصاغة لتناسب علامتك التجارية لمراجعاتك غير المعالجة — جاهزة في ثوانٍ.",
    sampleResponses: "ردود نموذجية",
    replyShootSuggestedResponse: "الرد المقترح من ReplyShoot",
    aiDrafted: "مسودة الذكاء الاصطناعي",
    nextSteps: "الخطوات التالية",
    emailThisReport: "إرسال هذا التقرير عبر البريد الإلكتروني",
    receivePdfCopy: "احصل على نسخة PDF من هذا التدقيق بالإضافة إلى فحص شهري مجاني لكيفية تتجه سمعتك.",
    sendReportBtn: "إرسال التقرير",
    sendingBtn: "جاري الإرسال...",
    letUsHandleThisTitle: "دعنا نتولى هذا نيابة عنك",
    letUsHandleThisDesc: "نستجيب لكل مراجعة — إيجابية وسلبية — بصوت علامتك التجارية في غضون 24 ساعة. ما عليك سوى الموافقة عبر البريد الإلكتروني.",
    startingAt15Mo: "تبدأ من 15 دولاراً/شهر · إلغاء في أي وقت · بدون عقود",
    runAnotherAudit: "تشغيل تدقيق آخر",

    // Tools Page
    toolsTitle: "مجموعة أدوات سمعة العلامة التجارية المحلية",
    toolsSub: "أدوات احترافية مصممة لمساعدتك في تحليل وتطوير تقييماتك المحلية دون تكاليف اشتراك.",
    toolsTag: "مجموعة أدوات سمعة مجانية للشركات المحلية",
    useTool: "استخدم الأداة ←",
    tool1Title: "تدقيق ملاحظات العلامة التجارية",
    tool1Desc: "افحص بسرعة عدد التقييمات عبر الإنترنت التي تُركت دون رد، وما قد تعنيه إضافة رد لها.",
    tool2Title: "مولد الرد الذكي",
    tool2Desc: "أدخل أي تعليق عميل لصياغة رد مهذب ومناسب لعلامتك التجارية وفوراً.",
    tool3Title: "مقدر هدف تقييم النجوم",
    tool3Desc: "احسب بدقة عدد تقييمات 5 نجوم المتتالية المطلوبة لرفع ملفك التجاري إلى نتيجتك المستهدفة.",
    tool4Title: "مقدر أثر الرد على الإيرادات",
    tool4Desc: "قدم حجم معاملتك المعتاد لتقدير الأثر المحتمل للمراجعات غير المعالجة.",
    tool5Title: "تحقق أمان HIPAA",
    tool5Desc: "الصق ردك لفحصه فوراً للكشف عن مخاطر السرية الطبية أو انتهاك HIPAA المحتملة.",
    tool6Title: "مخططات طلب المراجعة",
    tool6Desc: "انسخ والصق نصوص رسائل SMS والبريد الإلكتروني المجربة لطلب مراجعات صادقة من عملائك على Google.",

    // Onboarding Page
    howShouldWeSound: "كيف تريد أن تبدو نبرتنا؟",
    matchBrandVoice: "سنطابق صوت علامتك التجارية في كل رد.",
    toneProfessional: "احترافي",
    toneProfessionalDesc: "مصقول وعملي. ممتاز للخدمات الطبية والقانونية والمالية.",
    toneFriendly: "ودود ودافئ",
    toneFriendlyDesc: "مريح وقريب من العميل. ممتاز للمطاعم والمصالونات والتجزئة.",
    toneCasual: "عفوي",
    toneCasualDesc: "مستريح وغير رسمي. ممتاز للمقاهي واستوديوهات اللياقة البدنية.",
    toneEmpathetic: "متعاطف ومهتم",
    toneEmpatheticDesc: "حساس ومتفهم. ممتاز للرعاية الصحية والعافية ورعاية الأطفال.",
    uniqueQuestion: "ما الذي يجعل نشاطك التجاري فريداً؟",
    avoidQuestion: "هل هناك أي شيء ينبغي أن نتجنب ذكره؟",
    continueToPlan: "المتابعة لاختيار الخطة",
    chooseYourPlan: "اختر خطتك",
    noContractsNoFees: "إلغاء في أي وقت. بدون عقود. بدون رسوم إعداد.",
    planStarterDetails: "موقع واحد، مراجعات Google، استجابة خلال 48 ساعة",
    planProDetails: "موقع واحد، Google + Yelp + Facebook، استجابة خلال 24 ساعة",
    planMultiDetails: "حتى 3 مواقع، جميع المنصات، استجابة خلال 24 ساعة",
    continueToPayment: "المتابعة للدفع",
    savingText: "جاري الحفظ...",

    // Payment Page
    completeSubscription: "أكمل اشتراكك",
    trustPanelSub: "انضم إلى مئات الشركات المحلية التي تثق في ReplyShoot للحفاظ على نشاط مراجعاتها وبناء ثقة العملاء.",
    guaranteeTitle: "ألغِ في أي وقت، بدون عقود",
    guaranteeText: "لست ملزمًا بأي عقد - يمكنك إلغاء اشتراكك في أي وقت مباشرة من لوحة التحكم.",
    copywritersTitle: "مخصصة، وليست عامة",
    copywritersText: "يتم صياغة كل رد بالذكاء الاصطناعي بما يتناسب مع صوت علامتك التجارية الفريد — وليس قالباً عاماً أبداً.",
    controlTitle: "تحتفظ بالسيطرة الكاملة",
    controlText: "لا يتم نشر أي رد بدون موافقتك. تحقق من كل مسودة بنقرة واحدة عبر البريد الإلكتروني.",
    secureCheckoutPaddle: "الدفع الآمن مدعوم من Paddle. تفاصيل الدفع الخاصة بك مشفرة بالكامل وتخضع لمعايير PCI-DSS.",
    orderSummary: "ملخص الطلب",
    monthlyLabel: "شهري",
    billedAnnually: "تدفع سنوياً",
    save20: "وفر 20%",
    receiptEmail: "عنوان بريد الإيصال",
    receiptEmailPlaceholder: "you@yourbusiness.com",
    continueToCheckout: "المتابعة للدفع الآمن",
    goBack: "الرجوع للخلف",

    // Connect Google & OAuth
    connectGoogleAccount: "ربط حساب Google الخاص بك",
    googleConnectSub: "قم بتفويض ReplyShoot لجلب مراجعاتك بأمان ونشر ردود بالذكاء الاصطناعي — نيابة عنك 24/7.",
    googleConnectTag: "الملف التجاري لـ Google",
    step1Title: "انقر على \"ربط Google\"",
    step1Desc: "سيتم إعادة توجيهك بأمان إلى صفحة التفويض الخاصة بـ Google.",
    step2Title: "منح الأذونات",
    step2Desc: "سيطلب منك Google السماح بالوصول لعرض المراجعات والرد عليها على ملفك التجاري.",
    step3Title: "إرسال رمز من Google",
    step3Desc: "بعد الموافقة، يعيد Google التوجيه إلى تطبيقنا مع رمز تفويض آمن.",
    step4Title: "حفظ الرموز بأمان",
    step4Desc: "نتبادل الرمز برموز الوصول ونخزنها مشفرة — جاهزة لجلب المراجعات والرد عليها.",
    perm1: "عرض مواقع ملفك التجاري على Google",
    perm2: "قراءة جميع مراجعات العملاء في ملفك الشخصي",
    perm3: "نشر الردود على المراجعات نيابة عنك",
    perm4: "عرض معلومات الحساب الأساسية (الاسم، البريد)",
    checkingConnectionStatus: "جاري التحقق من حالة الاتصال…",
    googleAccountConnected: "حساب Google متصل",
    noGoogleAccountConnected: "لا يوجد حساب Google متصل",
    followStepsBelow: "اتبع الخطوات أدناه للبدء.",
    reconnectBtn: "إعادة الاتصال",
    connectingGoogle: "جاري الاتصال بـ Google...",
    authorizingGoogle: "جاري التفويض مع Google...",
    exchangingCode: "جاري تبادل رمز التفويض بأمان...",
    connectionSuccessful: "تم ربط حساب Google بنجاح!",
    autoRedirecting: "سيتم إعادة توجيهك إلى لوحة التحكم خلال ثوانٍ...",
    connectionFailed: "فشل ربط Google",
    connectionDenied: "تم رفض الموافقة على الوصول",
    connectionDeniedSub: "لقد ألغيت طلب إذن Google. نحتاج إذنك لجلب المراجعات وإدارتها.",
    tryConnectingAgain: "حاول الاتصال مرة أخرى",
    goToDashboard: "الذهاب إلى لوحة التحكم",

    // Dashboard (Customer & Admin)
    menu: "القائمة",
    overview: "نظرة عامة",
    reviews: "المراجعات",
    brandVoice: "إعدادات صوت العلامة التجارية",
    connectedLocations: "المواقع المتصلة",
    analytics: "التحليلات",
    billing: "الحساب / الفوترة",
    allCustomers: "جميع العملاء",
    auditRequests: "طلبات التدقيق",
    packageManager: "إدارة الباقات",
    systemSettings: "إعدادات النظام",
    approve: "موافقة",
    edit: "تعديل",
    reject: "رفض",
    saveChanges: "حفظ التغييرات",
    savedSuccessfully: "تم الحفظ بنجاح!",
    locationsConnectedLabel: "المواقع المتصلة",
    activePlanLabel: "الخطة النشطة",
    cancelSubscriptionBtn: "إلغاء الاشتراك",

    // Policy Pages Arabic (Terms, Privacy, Refund)
    termsSub: "شروط الخدمة والأحكام الخاصة باستخدام منصة إدارة المراجعات الخاصة بنا.",
    termsP1: "تصف هذه الشروط السياسات والشروط التي يمكنك بموجبها استخدام خدمات ReplyShoot، بما في ذلك تدقيق المراجعات وتوصيات الردود المولدة بالذكاء الاصطناعي وإدارة الاشتراكات.",
    acceptanceTitle: "الموافقة والقَبول",
    acceptanceDesc: "من خلال الوصول إلى ReplyShoot أو استخدامه، فإنك توافق على هذه الشروط، وسياسة الخصوصية الخاصة بنا، وأي سياسات إضافية منشورة على موقعنا.",
    eligibilityTitle: "الأهلية",
    eligibilityDesc: "يقتصر استخدام خدماتنا على الأفراد والشركات القادرة على إبرام عقود ملزمة. أنت تقر بأن عمرك لا يقل عن 18 عاماً وأنك مخول بقبول هذه الشروط نيابة عن الجهة التي تمثلها.",
    serviceDescTitle: "وصف الخدمة",
    serviceDescContent: "يوفر ReplyShoot أدوات لتدقيق المراجعات عبر الإنترنت، واقتراح رسائل الرد على العملاء، ومساعدة الأنشطة التجارية المحلية في تحسين سمعتها عبر الإنترنت. تقدم منصتنا الإرشادات والأتمتة، ولكنها لا تضمن نتائج مراجعة محددة أو تحسينات الترتيب.",
    userRespTitle: "مسؤوليات المستخدم",
    userResp1: "تقديم معلومات نشاط تجاري دقيقة أثناء التسجيل وطلبات التدقيق.",
    userResp2: "استخدام الخدمة بشكل قانوني واحترام حقوق الملكية الفكرية.",
    userResp3: "مراجعة والموافقة على أي محتوى يتم توليده بواسطة الذكاء الاصطناعي قبل نشره.",
    userResp4: "حماية بيانات اعتماد حسابك والإبلاغ عن أي وصول غير مصرح به فوراً.",
    billingFeesTitle: "الفواتير والرسوم",
    billingFeesDesc: "يتم تحديد أسعار الاشتراكات وشروط الفواتير والدفع عند الشراء. أنت توافق على دفع جميع الرسوم المطبقة والالتزام بسياسات الفواتير المنشورة.",
    ipTitle: "الملكية الفكرية",
    ipDesc: "جميع محتويات ReplyShoot والبرامج والتصميمات والعلامات التجارية مملوكة لـ ReplyShoot أو المرخصين لدينا. لا يجوز لك إعادة إنتاجها أو توزيعها أو إنشاء أعمال مشتقة منها دون إذن صريح.",
    thirdPartyTitle: "خدمات الطرف الثالث",
    thirdPartyDesc: "قد يتكامل ReplyShoot مع منصات خارجية، بما في ذلك مواقع المراجعة، ومزودي التحليلات، وبوابات الدفع. يخضع استخدام هذه الخدمات لشروطها وسياسات الخصوصية الخاصة بها.",
    disclaimerTitle: "إخلاء المسؤولية والمسؤولية القانونية",
    disclaimerDesc: "يقدم ReplyShoot الخدمات \"كما هي\" دون أي ضمانات للرواج أو الملاءمة لغرض معين. نحن لسنا مسؤولين عن أي أضرار غير مباشرة أو عرضية أو تبعية تنشأ عن استخدامك لمنصتنا.",
    terminationTitle: "إنهاء الخدمة",
    terminationDesc: "يجوز لنا تعليق أو إنهاء وصولك بسبب انتهاك هذه الشروط، أو عدم الدفع، أو إساءة استخدام المنصة. يمكنك إلغاء اشتراكك في أي وقت وفقاً لسياسات الإلغاء والاسترداد الخاصة بنا.",
    termsChangesTitle: "التعديلات",
    termsChangesDesc: "يجوز لنا تعديل هذه الشروط والسياسات في أي وقت. سيتم نشر التغييرات الجوهرية على موقعنا وقد يتم الإبلاغ عنها عبر البريد الإلكتروني. يعتبر الاستمرار في استخدام ReplyShoot بعد التحديثات بمثابة قبول بها.",

    privacySub: "كيف يجمع ReplyShoot معلوماتك ويستخدمها ويفصح عنها ويحميها.",
    privacyP1: "تشرح سياسة الخصوصية هذه كيف يجمع ReplyShoot المعلومات ويستخدمها ويفصح عنها ويحميها عندما تستخدم خدمات إدارة المراجعات والرد بالذكاء الاصطناعي. وتنطبق على مستخدمي موقعنا وأدوات التدقيق وتدفقات التهيئة والخدمات ذات الصلة.",
    infoWeCollectTitle: "المعلومات التي نجمعها",
    infoWeCollectSub: "نجمع المعلومات اللازمة لتقديم خدماتنا بفعالية وأمان.",
    contactDetailsTitle: "تفاصيل الاتصال والحساب:",
    contactDetailsDesc: "الاسم، عنوان البريد الإلكتروني، اسم النشاط التجاري، رقم الهاتف، والمعلومات الأخرى التي تقدمها أثناء التسجيل.",
    reviewDataTitle: "بيانات المراجعات والسمعة:",
    reviewDataDesc: "نص المراجعة، التقييمات، الطوابع الزمنية، معرفات المنصة، وأي تفاصيل نشاط تجاري مطلوبة لإنشاء توصيات دقيقة.",
    usageInfoTitle: "معلومات الاستخدام:",
    usageInfoDesc: "بيانات المتصفح والجهاز، مشاهدات الصفحات، نشاط الجلسة، ومعلومات التحليلات المجمعة عبر ملفات تعريف الارتباط.",
    howWeUseTitle: "كيف نستخدم معلوماتك",
    howWeUseSub: "نستخدم بياناتك لتقديم المنتجات وتحسين التجربة العامة.",
    howWeUse1: "تقديم تدقيق المراجعات، وصياغة الردود بالذكاء الاصطناعي، وإدارة الاشتراكات.",
    howWeUse2: "تخصيص توصياتنا وتكييف الردود لتناسب صوت علامتك التجارية.",
    howWeUse3: "إرسال إشعارات الخدمة، ومعلومات الفواتير، وتواصل الدعم الفني.",
    howWeUse4: "تحليل استخدام المنتج، وتحسين الأداء، وتطوير ميزات جديدة.",
    infoSharingTitle: "مشاركة المعلومات",
    infoSharingSub: "نشارك المعلومات فقط حسب الحاجة لتشغيل الخدمة وعند الضرورة القانونية.",
    serviceProvidersTitle: "مزودو الخدمة:",
    serviceProvidersDesc: "شركاء موثوقون يدعمون الاستضافة والتحليلات ومعالجة الدفع وتسليم البريد.",
    legalRequestsTitle: "الطلبات القانونية:",
    legalRequestsDesc: "عندما يقتضي القانون ذلك أو لحماية ReplyShoot أو عملائنا.",
    businessTransfersTitle: "نقل الأعمال:",
    businessTransfersDesc: "فيما يتعلق بعمليات الدمج أو الاستحواذ أو بيع الأصول.",
    securityRetentionTitle: "الأمان والاحتفاظ بالبيانات",
    securityRetentionDesc: "نحافظ على ضمانات معقولة مصممة لحماية بياناتك. نحتفظ بالمعلومات فقط طالما كان ذلك ضرورياً لتقديم الخدمات والامتثال للالتزامات القانونية.",
    yourRightsTitle: "حقوقك",
    yourRightsDesc: "قد تكون لديك حقوق في الوصول إلى معلوماتك الشخصية أو تصحيحها أو حذفها أو الاعتراض على استخدامات معينة لها بموجب القانون المعمول به.",
    cookiesTrackingTitle: "ملفات تعريف الارتباط وتتبع الاستخدام",
    cookiesTrackingDesc: "تساعدنا ملفات تعريف الارتباط والتقنيات المشابهة في تشغيل الموقع وتذكر التفضيلات وجمع بيانات التحليلات.",
    policyUpdatesTitle: "التحديثات",
    policyUpdatesDesc: "قد نحدث هذه السياسة بشكل دوري. سيتم نشر أي تغييرات جوهرية على موقعنا الإلكتروني.",

    refundSub: "إرشادات واضحة بشأن شروط وقواعد وطرق حساب الاسترداد.",
    refundP1: "تشرح سياسة الاسترداد هذه كيفية التعامل مع طلبات الاسترداد للااشتراكات الشهرية والسنوية في ReplyShoot.",
    monthlySubsTitle: "الاشتراكات الشهرية",
    monthlySubsSub: "يتم تقييم الاشتراكات الشهرية بناءً على دورة الفوترة وتاريخ تقديم طلب الاسترداد.",
    firstHalfTitle: "النصف الأول من الشهر:",
    firstHalfDesc: "طلبات الاسترداد المقدمة خلال النصف الأول من شهر الفوترة مؤهلة للحصول على استرداد بنسبة 50% من رسوم الشهر الحالي.",
    secondHalfTitle: "النصف الثاني من الشهر:",
    secondHalfDesc: "الطلبات المقدمة خلال النصف الثاني من شهر الفوترة غير مؤهلة لاسترداد رسوم الشهر الحالي.",
    exampleLabel: "مثال:",
    monthlyExample: "إذا بدأت فترة الفوترة في اليوم 1 وطلبت الاسترداد في اليوم 10، فقد تسترد 50% من رسوم ذلك الشهر. أما إذا تم الطلب في اليوم 20، فيعتبر الشهر الحالي مستحقاً بالكامل.",
    annualSubsTitle: "الاشتراكات السنوية",
    annualSubsSub: "تستخدم الاشتراكات السنوية نفس قاعدة النصف شهر للشهر الحالي، بالإضافة إلى استرداد لأي أشهر كاملة متبقية غير مستخدمة.",
    annualRule1: "إذا تم تقديم طلب الاسترداد في النصف الأول من الشهر الحالي، فإن 50% من رسوم الشهر الحالي قابلة للاسترداد.",
    annualRule2: "إذا تم تقديم الطلب في النصف الثاني، فإن رسوم الشهر الحالي غير قابلة للاسترداد.",
    annualRule3: "يتم استرداد الأشهر الكاملة المتبقية غير المستخدمة من المدة السنوية بسعر السعر الشهري المكافئ.",
    annualExample: "إذا كان تاريخ الفوترة السنوي هو 5 يناير وطلبت استرداداً في 8 مارس، فقد تتلقى 50% عن مارس بالإضافة إلى استرداد الأشهر غير المستخدمة من أبريل إلى ديسمبر.",
    processingTitle: "المعالجة والتنفيذ",
    processingDesc: "يتم إصدار المبالغ المستردة إلى طريقة الدفع المستخدمة للشراء. تختلف أوقات المعالجة حسب مزود خدمة الدفع وقد تستغرق عدة أيام عمل.",
    cancellationAccessTitle: "الإلغاء وصلاحية الوصول",
    cancellationAccessDesc: "عند الموافقة على الاسترداد، قد يظل اشتراكك نشطاً حتى نهاية الفترة المدفوعة ما لم يذكر خلاف ذلك في إشعار حسابك.",
    refundUpdatesTitle: "تحديثات السياسة",
    refundUpdatesDesc: "قد يغير ReplyShoot سياسة الاسترداد هذه في أي وقت. سيتم نشر السياسات المحدثة على موقعنا الإلكتروني وتنطبق على عمليات الشراء المستقبلي.",
  }
};

export default translations;
